<template>
  <div class="container">
    <div class="left-panel">
      <div class="posts">
        <div v-for="(post, index) in posts" :key="index" class="post">
          <div class="post-header">
            <img class="profile-image" src="https://www.w3schools.com/w3images/avatar1.png" alt="Profile Image">
            <strong v-if="post.is_anonymous == 1">{{ $t('anonymous') }}</strong>
            <strong v-else>{{ post.username }}</strong>
            <span class="timestamp">{{ formatDate(post.timestamp) }}</span>
          </div>
          <p>{{ post.content }}</p>
          <div class="badges">
            <span class="badge">{{ $t(`allCountry.${post.country}`, post.country) }}</span>
            <span class="badgeTheme">{{ $t(`allTheme.${post.theme}`, post.theme) }}</span>
          </div>
          <!---<div class="reactions">
            <span v-for="(emoji, key) in reactions" :key="key" @click="toggleReaction(index, key)" class="reaction">
              {{ emoji }} {{ post.reactionCounts[key] || 0 }}
            </span>
          </div>-->
        </div>
      </div>
      <button @click="openPopup" class="add-post-btn">+</button>
    </div>

    <div class="right-panel">
      <h2>{{ $t('filter') }}</h2>
      <div class="filters">
        <select v-model="selectedCountry">
          <option value="0">{{ $t('countries') }}</option>
          <option v-for="country in countries" :key="country.id" :value="country.id">
            {{ $t(`allCountry.${country.name}`, country.name) }}
            ({{ country.usage_count }})
          </option>
        </select>

        <select v-model="selectedTheme">
          <option value="0">{{ $t('themes') }}</option>
          <option v-for="theme in themes" :key="theme.id" :value="theme.id">
            {{ $t(`allTheme.${theme.name}`, theme.name) }}

            ({{ theme.usage_count }})
          </option>
        </select>
      </div>

      <p>{{ $t('map') }}</p>

      <div id="">
        <MapComponent :posts="posts" :key="map" />
      </div>

      <div class="language-selector">
        <div class="selected-language" @click="toggleDropdown">
          <img :src="languages[selectedLanguage].flag" :alt="languages[selectedLanguage].name" width="24" height="16">
          {{ languages[selectedLanguage].name }}
        </div>
        <div v-if="showDropdown" :class="['dropdown', dropdownClass]">
          <div v-for="(lang, key) in languages" :key="key" @click="changeLanguage(key)" class="dropdown-item">
            <img :src="lang.flag" :alt="lang.name" width="24" height="16"> {{ lang.name }}
          </div>
        </div>
      </div>

    </div>

    <div v-if="isPopupVisible" class="popup-overlay">
      <div class="popup">
        <h3>{{ $t('expression') }}</h3>
        <div class="input-group">
          <input v-model="data.username" :disabled="data.isAnonymous" :placeholder="$t('name')" />
          <label>
            <input type="checkbox" v-model="data.isAnonymous" /> {{ $t('anonymous') }}
          </label>
        </div>
        <select v-model="data.country">
          <option value="" disabled>{{ $t('country') }}</option>
          <option v-for="country in countries" :key="country.id" :value="country.id">
            {{ $t(`allCountry.${country.name}`, country.name) }}
          </option>
        </select>
        <select v-model="data.theme">
          <option value="" disabled>{{ $t('category') }}</option>
          <option v-for="theme in themes" :key="theme.id" :value="theme.id">{{ $t(`allTheme.${theme.name}`,
            theme.name) }}</option>
        </select>
        <textarea v-model="data.content" :placeholder="$t('content')"></textarea>
        <button @click="submitPost" class="submit-btn">{{ $t('publish') }}</button>
        <button @click="closePopup" class="cancel-btn">{{ $t('cancel') }}</button>
      </div>

    </div>
  </div>
</template>

<script>
import apiService from '@/services/apiService';
import moment from 'moment';
import MapComponent from './components/MapComponent.vue';

import { Notyf } from 'notyf';
import 'notyf/notyf.min.css';
const notyf = new Notyf();


export default {
  data() {
    return {
      posts: [],
      reactions: {
        like: '👍',
        angry: '😡',
        wow: '😮'
      },
      data: {
        theme: "",
        country: "",
        username: "Anonyme",
        content: "",
        isAnonymous: false
      },
      selectedLanguage: this.$i18n.locale,
      languages: {
        en: { name: "En", flag: "https://flagcdn.com/w40/gb.png" },
        fr: { name: "Fr", flag: "https://flagcdn.com/w40/fr.png" },
        es: { name: "Es", flag: "https://flagcdn.com/w40/es.png" },
        de: { name: "De", flag: "https://flagcdn.com/w40/de.png" },
        it: { name: "It", flag: "https://flagcdn.com/w40/it.png" },
        pt: { name: "Pt", flag: "https://flagcdn.com/w40/pt.png" },
        nl: { name: "Nl", flag: "https://flagcdn.com/w40/nl.png" },
        ja: { name: "Ja", flag: "https://flagcdn.com/w40/jp.png" },
      },
      countries: [],
      themes: [],
      selectedCountry: "0",
      selectedTheme: "0",
      newPostContent: '',
      dropdownClass: '',
      me: null,
      socketNewPost: null,
      map: 0,
      isPopupVisible: false,
      showDropdown: false,
    };
  },
  components: {
    MapComponent
  },

  async mounted() {
    const userLanguage = navigator.language.split('-')[0];
    const lang = localStorage.getItem('language') || userLanguage;
    this.selectedLanguage = lang;

    // SEO Title
    document.title = "Cry4Change - Exprimez-vous";

    // SEO Meta Description
    let descriptionMetaTag = document.querySelector('meta[name="description"]');
    if (descriptionMetaTag) {
      descriptionMetaTag.setAttribute("content", "Exprimez vos idées, vos frustrations et vos rêves avec Cry4Change. Un espace où chaque voix compte et où le changement commence par un simple cri.");
    } else {
      descriptionMetaTag = document.createElement('meta');
      descriptionMetaTag.name = "description";
      descriptionMetaTag.content = "Exprimez vos idées, vos frustrations et vos rêves avec Cry4Change. Un espace où chaque voix compte et où le changement commence par un simple cri.";
      document.head.appendChild(descriptionMetaTag);
    }

    // Open Graph (OG) Meta Tags for Facebook and WhatsApp
    let ogTitle = document.createElement('meta');
    ogTitle.setAttribute('property', 'og:title');
    ogTitle.content = "Cry4Change - Exprimez-vous";
    document.head.appendChild(ogTitle);

    let ogDescription = document.createElement('meta');
    ogDescription.setAttribute('property', 'og:description');
    ogDescription.content = "Exprimez vos idées, vos frustrations et vos rêves avec Cry4Change. Un espace où chaque voix compte et où le changement commence par un simple cri.";
    document.head.appendChild(ogDescription);

    let ogImage = document.createElement('meta');
    ogImage.setAttribute('property', 'og:image');
    ogImage.content = require('@/assets/logo.png'); 
    document.head.appendChild(ogImage);

    let ogUrl = document.createElement('meta');
    ogUrl.setAttribute('property', 'og:url');
    ogUrl.content = window.location.href;
    document.head.appendChild(ogUrl);

    let ogType = document.createElement('meta');
    ogType.setAttribute('property', 'og:type');
    ogType.content = "website";
    document.head.appendChild(ogType);

    // Twitter Card Meta Tags
    let twitterCard = document.createElement('meta');
    twitterCard.setAttribute('name', 'twitter:card');
    // twitterCard.content = "summary_large_image";
    twitterCard.content = require('@/assets/logo.png'); 
    document.head.appendChild(twitterCard);

    let twitterTitle = document.createElement('meta');
    twitterTitle.setAttribute('name', 'twitter:title');
    twitterTitle.content = "Cry4Change - Exprimez-vous";
    document.head.appendChild(twitterTitle);

    let twitterDescription = document.createElement('meta');
    twitterDescription.setAttribute('name', 'twitter:description');
    twitterDescription.content = "Exprimez vos idées, vos frustrations et vos rêves avec Cry4Change. Un espace où chaque voix compte et où le changement commence par un simple cri.";
    document.head.appendChild(twitterDescription);

    let twitterImage = document.createElement('meta');
    twitterImage.setAttribute('name', 'twitter:image');
    twitterImage.content = require('@/assets/logo.png'); 
    document.head.appendChild(twitterImage);
    // FIN SEO

    this.countries = await apiService.getCountries();
    this.themes = await apiService.getThemes();
    this.posts = await apiService.getPosts();
    this.map = this.map + 1;
    this.me = await apiService.getLastMe() || null;
    // initialiser l'ajout
    this.data.country = this.me?.country_id || ""
    this.data.theme = this.me?.theme_id || ""
    // Écouter les nouveaux posts en temps réel
    this.socketNewPost = await apiService.listenForNewPost();
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;

      // Vérifie la position de la liste pour savoir s'il faut ouvrir en haut ou en bas
      this.$nextTick(() => {
        const selector = this.$el.querySelector('.selected-language');
        const rect = selector.getBoundingClientRect();
        const spaceAbove = rect.top; // Espace disponible en haut
        const spaceBelow = window.innerHeight - rect.bottom; // Espace disponible en bas

        // Si l'espace au-dessus est plus grand que celui en bas, on ouvre le dropdown vers le haut
        if (spaceAbove > spaceBelow) {
          this.dropdownClass = 'open-up';
        } else {
          this.dropdownClass = '';
        }
      });
    },
    openPopup() {
      this.isPopupVisible = true;
    },
    closePopup() {
      this.isPopupVisible = false;
      this.data = {
        theme: "",
        country: "",
        username: "Anonyme",
        content: "",
        isAnonymous: false
      };
    },
    formatDate(date) {
      return moment(date).fromNow();
    },
    changeLanguage(lang) {
      this.selectedLanguage = lang;
      this.$i18n.locale = this.selectedLanguage;
      localStorage.setItem('language', lang);
      this.showDropdown = false;
    },
    toggleReaction(postIndex, reaction) {
      const post = this.posts[postIndex];
      if (!post.reactionCounts[reaction]) {
        this.$set(post.reactionCounts, reaction, 1);
      } else {
        post.reactionCounts[reaction]++;
      }
    },
    async submitPost() {
      if (this.data.country != "" && this.data.theme != "" && this.data.content.trim()) {
        try {
          const postData = {
            country: this.data.country,
            theme: this.data.theme,
            username: this.data.username,
            content: this.data.content,
            isAnonymous: this.data.isAnonymous
          };

          try {
            await apiService.submitPost(postData);
            this.posts = await apiService.getPosts();
          } catch (error) {
            if (error.response && error.response.data && error.response.data.error) {
              notyf.error({
                message: error.response.data.error,
                duration: 5000
              });
            } else {
              notyf.error({
                message: 'Une erreur est survenue, veuillez réessayer plus tard.',
                duration: 5000
              });
            }
          }
          this.closePopup();
        } catch (error) {
          console.error('Erreur lors de la soumission:', error);
        }
      } else {
        console.error('Tous les champs doivent être remplis');
      }
    }
  },
  watch: {
    async socketNewPost() {
      this.posts = await apiService.getPosts();
    },
    async selectedCountry() {
      if (this.selectedCountry == "0" && this.selectedTheme == "0") {
        this.posts = await apiService.getPosts();
      } else {
        this.posts = await apiService.getPostsByQuery(this.selectedCountry, this.selectedTheme) || [];
      }
    },
    async selectedTheme() {
      if (this.selectedCountry == "0" && this.selectedTheme == "0") {
        this.posts = await apiService.getPosts();
      } else {
        this.posts = await apiService.getPostsByQuery(this.selectedCountry, this.selectedTheme) || [];
      }
    }
  },
};
</script>

<style scoped></style>
